module.exports = new __parcel__URL__("gallery_15.a2518854.jpeg").toString();